import React from 'react';
import "../LandingPage.css"
const CardIntroduction = () => {
    return (
        <div className="card-wrapper-content">
            <h1>How It Works</h1>
            <p>We - can save your time, can save your money.</p>
            <div className="introduction-card-wrapper">
            </div>
        </div>
    );
};

export default CardIntroduction;